import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class WorkflowConfigService extends RLBaseService {

    static $inject = ["$resource", "$q"];

    constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService) {
        super($resource);
    }

    getActionConfigs(processID: number, charTypeID: number) {
        var data = {
            processID: processID,
            charTypeID: charTypeID
        };
        return this.toRLService<Models.IWFActionConfig>("/api/workflowconfig/getworkflowconfigactions").query(data).$promise;
    }

    getActions(processID: number) {
        var data = {
            processID: processID
        };
        return this.toRLService<Models.IWFActionConfig>("/api/workflowconfig/getactions").query(data).$promise;
    }

    getAffectedEntitiesCount(stepConfig: Models.IWFStepSaveRequest) {
        return this.toRLService<Models.IDataResponse<number>>("/api/workflowconfig/getaffectedentitiescount").post(stepConfig).$promise;
    }

    updateWFStepRelatedEntities(stepConfig: Models.IWFStepSaveRequest) {
        return this.toRLService<void>("/api/workflowconfig/UpdateWFStepRelatedEntities").post(stepConfig).$promise;
    }

    getEditAction(processID: number, actionID: number, charTypeID: number) {
        var data = {
            processID: processID,
            actionID: actionID,
            charTypeID: charTypeID
        };
        return this.toRLService<Models.IWFActionConfig>("/api/workflowconfig/GetWorkflowEditAction").post(data).$promise;
    }

    getPreviewNotifications(processID: number, actionID: number) {
        var data = {
            processID: processID,
            actionID: actionID,
        };
        return this.toRLService<Models.IWFPreviewNotifications>("/api/workflowconfig/getPreviewNotifications").post(data).$promise;
    }

    getProcesses(charTypeID: number) {
        var data = {
            charTypeID: charTypeID
        };
        return this.toRLService<Models.IWFProcess>("/api/workflowconfig/getprocesses").query(data).$promise;
    }
    getNotifications(processID: number) {
        var data = {
            processID: processID
        };
        return this.toRLService<Models.IWFRoleNotification>("/api/workflowconfig/getnotifications").query(data).$promise;
    }
    getProcessesWithSteps(charTypeID: number) {
        var data = {
            charTypeID: charTypeID
        };
        return this.toRLService<Models.IWFProcessConfig>("/api/workflowconfig/getprocesseswithstepsconfig").query(data).$promise;
    }

    getSteps(processID: number) {
        var data = {
            processID: processID
        };
        return this.toRLService<Models.IWFStep>("/api/workflowconfig/getwfsteps").query(data).$promise;
    }

    getAssociatedSteps(processID: number, actionID: number) {
        var data = {
            processID: processID,
            actionID: actionID
        };
        return this.toRLService<Models.IWFStep>("/api/workflowconfig/getactionstepassociations").query(data).$promise;
    }

    getAssociatedActions(processID: number, stepID: number) {
        var data = {
            processID: processID,
            stepID: stepID
        };
        return this.toRLService<Models.IWFAssocAction>("/api/workflowconfig/getstepactionassociations").query(data).$promise;
    }

    getAssociatedRoles(processID: number, actionID: number) {
        var data = {
            processID: processID,
            actionID: actionID
        };
        return this.toRLService<Models.IWFActionRoleConfig>("/api/workflowconfig/getassociatedroles").query(data).$promise;
    }

    getRoleActions(processID: number, roleID: number) {
        var data = {
            processID: processID,
            roleID: roleID
        };
        return this.toRLService<Models.IWFRoleActionAssoc>("/api/workflowconfig/getroleactions").query(data).$promise;
    }

    getStepRoleAssoc(processID: number, stepID: number) {
        var data = {
            processID: processID,
            stepID: stepID
        };
        return this.toRLService<Models.IWFStepRoleAssoc>("/api/workflowconfig/getsteproleassociations").query(data).$promise;
    }

    getRoleStepAssoc(processID: number, roleID: number) {
        var data = {
            processID: processID,
            roleID: roleID
        };
        return this.toRLService<Models.IWFStepRoleAssoc>("/api/workflowconfig/getrolestepassociations").query(data).$promise;
    }

    getParties() {
        return this.toRLService<Models.IParty>("/api/workflowconfig/getparties").query().$promise;
    }

    getPartiesWithNotifications(processID: number, actionID: number) {
        var data = {
            processID: processID,
            actionID: actionID
        };
        return this.toRLService<Models.IPartyWithNotification>("/api/workflowconfig/getpartylist").query(data).$promise;
    }

    getRoles() {
        return this.toRLService<Models.IWFActionRoleConfig>("/api/workflowconfig/getwfroles").query().$promise;
    }

    saveAction(actionConfig: Models.IWFActionSaveRequest) {
        return this.toRLService<number>("/api/workflowconfig/saveworkflowaction").post(actionConfig).$promise;
    }

    saveStep(stepConfig: Models.IWFStepSaveRequest) {
        return this.toRLService<number>("/api/workflowconfig/savewfstep").post(stepConfig).$promise;
    }

    saveProcess(process: Models.IWFProcess) {
        return this.toRLService<number>("/api/workflowconfig/savewfprocess").post(process).$promise;
    }

    deleteAction(processID: number, actionID: number) {
        var data = {
            processID: processID,
            actionID: actionID
        };
        return this.toRLService<boolean>("/api/workflowconfig/deleteworkflowaction").post(data).$promise;
    }

    deleteStep(processID: number, stepID: number) {
        var data = {
            processID: processID,
            stepID: stepID
        };
        return this.toRLService<Models.IDataResponse<boolean>>("/api/workflowconfig/deleteworkflowstep").post(data).$promise;
    }

    getProcessTemplateCount(processID: number) {
        return this.toRLService<any>("/api/workflowconfig/getprocesstemplatecount").get({ processID: processID }).$promise;
    }

    deleteProcess(processID: number) {
        var data = {
            processID: processID
        };
        return this.toRLService<any>("/api/workflowconfig/deletewfprocess").post(data).$promise;
    }

    deleteNotification(notificationID: number, processID: number) {
        var data = {
            notificationID: notificationID,
            processID: processID
        };
        return this.toRLService<boolean>("/api/workflowconfig/deletewfnotification").post(data).$promise;
    }

    saveNotification(notification: Models.IWFRoleNotification) {
        return this.toRLService<number>("/api/workflowconfig/savewfnotification").post(notification).$promise;
    }

    getDocTemplateTypes() {
        return this.toRLService<Models.IWFDocumentTemplateType>("/api/workflowconfig/getdoctemplatetypes").query().$promise;
    }

    saveStepPermissions(stepRoleRequest: Models.IWFStepRoleAssocRequest) {
        return this.toRLService<void>("/api/workflowconfig/savesteproles").post(stepRoleRequest).$promise;
    }
    saveActionPermissions(actionRoleRequest: Models.IWFActionRoleAssocRequest) {
        return this.toRLService<void>("/api/workflowconfig/saveactionroles").post(actionRoleRequest).$promise;
    }
    entityStatusAdminSearch(query: Models.ISearchRequest) {
        return this.toRLService<Models.IAssetSearchResult>("/api/workflowconfig/entityadminsearch/").post(query).$promise;
    }

    getStatusesForEntity(charTypeID: number, recID: number) {
        var data = {
            charTypeID: charTypeID,
            recID: recID
        };
        return this.toRLService<Models.IWFEntityStatusResult>("/api/workflowconfig/GetStatusesForEntity").post(data).$promise;
    }

    getWorkflowActionExtensions(processID: number, actionID: number) {
        var data = {
            processID: processID,
            actionID: actionID
        }
        return this.toRLService<Models.IWFActionExtensionResult>("/api/workflowconfig/GetWorkflowActionExtensions").post(data).$promise;
    }

    updateWorkflowProcessSequenceNumber(processID: number, direction: boolean) {
        var data = {
            processID: processID,
            direction: direction
        };
        return this.toRLService<void>("/api/workflowconfig/updateWorkflowProcessSequenceNumber").post(data).$promise;
    }

    updateWorkflowStepSequenceNumber(processID: number, stepID: number, direction: boolean) {
        var data = {
            processID: processID,
            stepID: stepID,
            direction: direction
        };
        return this.toRLService<void>("/api/workflowconfig/updateWorkflowStepSequenceNumber").post(data).$promise;
    }

    updateWorkflowActionSequenceNumber(processID: number, actionID: number, direction: boolean) {
        var data = {
            processID: processID,
            actionID: actionID,
            direction: direction
        };
        return this.toRLService<void>("/api/workflowconfig/updateWorkflowActionSequenceNumber").post(data).$promise;
    }

    updateWorkflowNotificationSequenceNumber(processID: number, notificationID: number, direction: boolean) {
        var data = {
            processID: processID,
            notificationID: notificationID,
            direction: direction
        };
        return this.toRLService<void>("/api/workflowconfig/updateWorkflowNotificationSequenceNumber").post(data).$promise;
    }
}